export var MuiButtonBase = {
    defaultProps: { disableRipple: true, focusRipple: false },
};
